import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { CreateCompanyIconSvgComponent } from '../../../../modules/mapfre-design-library/src/lib/svg/create-company-icon-svg/create-company-icon-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBase,
  FormBaseControlService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ModalOptions } from '@mapfre-design-library/src/public_api';
import { UserService } from '../../../../_services/user.service';
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { Router , RouterModule } from '@angular/router';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { ClientCredentialsTokenService } from '../../../../_services/client-credentials/client-credentials-token.service';
import { ClientCredentialsService } from '../../../../_services/client-credentials/client-credentials.service';
import { CreateAccountService } from '../../../../_services/forms/create-account/create-account-service.service';
import { Location } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CreateCompanyIconSvgComponent, MapfreIputWithValidationComponent, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-create-commercial-account',
  templateUrl: './create-commercial-account.component.html',
})
export class CreateCommercialAccountComponent implements OnInit {
  inputs: FormBase<any>[];
  createCommercialAcForm: FormGroup;
  companyInvoiceModalOptions: ModalOptions;
  loader = false;
  user: any = {};
  isAcmic = false;
  isInValidCompanyInput = false;

  constructor(
    private ipt: FormBaseControlService,
    private authService: AuthenticationService,
    private userData: UserService,
    private router: Router,
    private errorRedirectionService: ErrorRedirectionService,
    private clientCredentialsService: ClientCredentialsService,
    private clientCredentialsTokenService: ClientCredentialsTokenService,
    private createAccountService: CreateAccountService,
    private titleService: Title,
    private meta: Meta,
    private acmicService: AcmicService,
    private location: Location
  ) {
    this.inputs = createAccountService.getCommercialAcInputs();
  }

  createCommercialAcObj(object, numbers, publicId): void {
    if (numbers === null) {
      this.user.userDetails = {
        firstName: object.createAc_companyName.trim(),
        middleName: '',
        lastName: '',
        email: {
          address: object.createAc_email,
        },
      };
    } else {
      this.user.userDetails['publicId'] = publicId;
      this.user.policyDetail = numbers;
    }
    this.userData.placeUserInfoInStorage(this.user);
    this.userData.setCommercialAcFlag(true);
    this.userData.updateUser(this.user);
  }

  createCommercialAccount() {
    if (this.loader) {
      return false;
    }
    this.loader = true;
    this.createCommercialAcObj(this.createCommercialAcForm.value, null, null);
    const res = {
      policynumber: [],
    };
    if (this.userData) {
      this.authService.verifyUser(this.userData).subscribe(
        (result: any) => {
          if (result) {
            this.loader = false;
            result.forEach((policy) => {
              res.policynumber.push({
                policyNumber: policy.policynumber.policyNumber,
              });
            });
            const publicId = result[0].insured.filter((insured) => {
              return (
                insured['Insured Name'].toLowerCase().trim() ===
                this.createCommercialAcForm.value.createAc_companyName
                  .toLowerCase()
                  .trim()
              );
            });
            this.createCommercialAcObj(
              this.createCommercialAcForm.value,
              res,
              publicId[0]['publicId']
            );
            this.router.navigate(['signup', 'createpassword']);
          }
        },
        (err) => {
          this.loader = false;
          if (err.status === 400) {
            // --- Email is already in use
            this.router.navigate(['signup', 'email-in-use']);
          } else if (err.status === 403) {
            // --- If the user does not have any policies
            this.router.navigate(['signup', 'add-policy']);
          } else {
            this.errorRedirectionService.redirect(err.status);
          }
        }
      );
    }
  }
  isValidInput(valid, key): void {
    if (key === 'createAc_companyName') {
      this.isInValidCompanyInput = !valid;
    }
  }
  fromTheBackButton(): void {
    this.userData.$user.subscribe((user: any) => {
      if (user && user.userDetails && user.userDetails.lastName === '') {
        this.createCommercialAcForm.controls.createAc_companyName.setValue(
          user.userDetails.firstName || ''
        );
        this.createCommercialAcForm.controls.createAc_email.setValue(
          user.userDetails.email.address || ''
        );
      }
    });
  }
  goBack() {
    this.location.back();
  }
  ngOnInit() {
    this.createCommercialAcForm = this.ipt.toFormGroup(this.inputs);
    this.fromTheBackButton();
    this.isAcmic = this.acmicService.isACMIC();
    this.companyInvoiceModalOptions = new ModalOptions({
      additionalClasses: 'modal-small center-on-page modal-dialog',
      additionalButtonClasses:
        'no-padding-horizontal link-button blue-link font-weight normal-text ',
      animatePosition: 'bottom',
      buttonCopy: 'EXACTLY_APPEARS_ON_INVOICE_LINK',
      modalId: 'helpModal',
      modalTranslateCopy: 'REVIEW_COMPANY_NAME',
      typeOfModal: 'default',
      modalName: 'company_Invoice',
    });
    if (!this.clientCredentialsTokenService.getToken()) {
      this.clientCredentialsService.getToken().subscribe();
    }
    this.titleService.setTitle('Create a Business Insurance Customer Account | Mapfre Insurance');
    this.meta.updateTag({ name: 'description', content: 'Create a customer account and manage your Mapfre Insurance commercial business policy with ease.' });
  }
}
